import StatCard from '../../../../Components/StatCard/StatCard';
import { useSelector } from 'react-redux';

function LensStats() {
    const lensInsights = useSelector((state) => state.reportAnalysis.lensInsights.lensInsights);

    return (
        <div className="grid grid-cols-4 gap-x-3 mx-5 mt-4">
            {
                Object.keys(lensInsights).length > 0 && 
                <>
                    <StatCard 
                        statName="On Favourites"
                        statValue={lensInsights.stats.onFav} 
                        // statTrend={12}
                    />
                    <StatCard 
                        statName="Account Reached"
                        statValue={0} 
                        // statTrend={12}
                    />
                    <StatCard 
                        statName="Account Engaged"
                        statValue={0} 
                        // statTrend={-24}
                    />
                    <StatCard 
                        statName="Content Shared"
                        statValue={0}
                    />
                </>
            }
        </div>
    )
}

export default LensStats;
